import EditorJS from "@editorjs/editorjs";
import { DragDrop as EditorDragDrop } from "./dragdrop";
import "./custom.css";

export { EditorJS, EditorDragDrop }
